import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import './index.css';
import App from './App';
import { Provider } from "react-redux";
import store from './store';
import { Suspense } from 'react';

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(
  <Suspense fallback={<div>Loading app...</div>}>
    <Provider store={store}>
      <BrowserRouter future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}>
        <App />
      </BrowserRouter>
    </Provider>
  </Suspense>
);
